// The Striping Plan list actions (spec 2026-10-14 Part A) as useRsaPaths exposes them.
// Each marks a local change (beforeChange, so a slow first load can't overwrite it) and
// dispatches one PATH_ACTIONS case; the add actions return the new point ids.
import { PATH_ACTIONS } from './rsaPathsReducer';
import { makePoint } from '../InternalComponents/stripingList';

const defaultNewId = () => crypto.randomUUID();

export function makeStripingActions(dispatch, { newId = defaultNewId, beforeChange = () => {} } = {}) {
  const run = (action) => {
    beforeChange();
    dispatch(action);
  };
  return {
    addStripingIntersection: (pathId, { lat, lng, name = '' }) => {
      const id = newId();
      run({ type: PATH_ACTIONS.ADD_STRIPING_INTERSECTION, pathId, point: makePoint({ id, lat, lng, name }) });
      return id;
    },
    addStripingIntersections: (pathId, points) => {
      const made = (points || []).map((p) => makePoint({ ...p, id: newId() }));
      run({ type: PATH_ACTIONS.ADD_STRIPING_INTERSECTIONS, pathId, points: made });
      return made.map((p) => p.id);
    },
    moveStripingIntersection: (pathId, id, lat, lng) =>
      run({ type: PATH_ACTIONS.MOVE_STRIPING_INTERSECTION, pathId, id, lat, lng }),
    renameStripingIntersection: (pathId, id, name) =>
      run({ type: PATH_ACTIONS.RENAME_STRIPING_INTERSECTION, pathId, id, name }),
    deleteStripingIntersection: (pathId, id) =>
      run({ type: PATH_ACTIONS.DELETE_STRIPING_INTERSECTION, pathId, id }),
    setStripingIntersections: (pathId, points) =>
      run({ type: PATH_ACTIONS.SET_STRIPING_INTERSECTIONS, pathId, points }),
  };
}
